export default __webpack_public_path__ + "static/media/OlentzeroTxirriMirrietaTxiribiton.9cc83561.mp3";